// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__zSPWS","author":"Table_author__zEI2b","authorImage":"Table_authorImage__2MmLv","unreadRow":"Table_unreadRow__2Rjhk"};